import { createAsyncThunk } from '@reduxjs/toolkit';
import { RemoveImageDocumentSignalRResponse } from '@v2/components/imageHandling/types/types';
import { AppDispatch } from '@store/types';
import { pushMessage } from '@reducers/v2/messagesBus/messagesBus.slice';
import { restoreRemoveImageDocument } from '@reducers/v2/imageHandlingV2/restoreFunctions';
import { ImageDocumentMessageType } from '@reducers/v2/messagesBus/types';

export const removeImageDocumentMessageProducer = createAsyncThunk<void, RemoveImageDocumentSignalRResponse, { dispatch: AppDispatch }>(
  'imageHandlingV2/removeImageDocumentMessageProducer',
  async (params, { dispatch }) => {
    if (!params.isError) {
      dispatch(
        pushMessage({
          key: params.documentId,
          message: {
            messageType: ImageDocumentMessageType.IMAGE_DELETED,
            payload: params,
          },
        })
      );
    } else {
      dispatch(restoreRemoveImageDocument({ documentId: params.documentId, errorMessage: params.errorMessage }));
    }
  }
);
